export const environment = {
  apiBaseUrl: 'https://yjf317gf5e.execute-api.us-east-1.amazonaws.com/v1',
  apiCallBaseUrl: 'undefined',
  wssBaseUrl: 'wss://5tsjqx94e2.execute-api.us-east-1.amazonaws.com/production/',
  userPoolClientId: '217rsam8nd8vi9jihb30g1r2c8',
  userPoolId: 'us-east-1_NOYRSvrVo',
  domain: 'auth-prod-users-k8bs.auth.us-east-1.amazoncognito.com',
  redirectSignIn: '["https://app.justsext.com","https://app.stxt.ai/","https://www.app.justsext.com","https://www.app.stxt.ai/"]',
  redirectSignOut: '["https://app.justsext.com/","https://app.stxt.ai/","https://www.app.justsext.com/","https://www.app.stxt.ai/"]',
  analyticsKey: 'Ax6dYlHqFER10BEsx93QuAK5gGkejxGT',
  recaptchaSiteKey: '6Lfka0wqAAAAAAu1t4bKZk4vzxBYOKdQWTH4Fgs9',
  statsigKey: 'client-yigFR9cE1l11NfONYIFjMGMoDeIOZq4Frnp2onSLiBS',
  sentryDsn: 'https://f6d2e41e63562866d33e0f0542859d48@o4505800103755776.ingest.us.sentry.io/4507983054438400',
  sentryAuthToken: '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',
  serviceEnvironment: 'production',
  gtm: {
    id: 'GTM-NKVF2535',
    auth: 'c5uCD6Maz5QwqHLfXBoxGw',
    preview: 'env-1',
  },
  production: true,
};